import PropTypes from 'prop-types'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion'
import { cn } from 'lib/utils'

// Note: AdasAccordion wraps a single expandable panel. It is not designed for
// multi-item accordion lists. Each usage should contain exactly one
// AdasAccordionSummary and one AdasAccordionDetails.
export const AdasAccordion = ({ children, defaultExpanded, className, expanded, onChange, sx, ...props }) => (
  <Accordion
    type='single'
    collapsible
    defaultValue={defaultExpanded ? 'item-0' : undefined}
    value={expanded !== undefined ? (expanded ? 'item-0' : '') : undefined}
    onValueChange={(val) => onChange && onChange(null, val === 'item-0')}
    className={cn('w-full', className)}
    {...props}
  >
    <AccordionItem value='item-0' className='border-0'>
      {children}
    </AccordionItem>
  </Accordion>
)

export const AdasAccordionSummary = ({ children, expandIcon, className, sx, ...props }) => (
  <AccordionTrigger className={cn('hover:no-underline px-4 py-3', className)} {...props}>
    {children}
  </AccordionTrigger>
)

export const AdasAccordionDetails = ({ children, className, sx, ...props }) => (
  <AccordionContent className={cn('px-4 pb-3', className)} {...props}>
    {children}
  </AccordionContent>
)

AdasAccordion.propTypes = {
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  className: PropTypes.string,
  expanded: PropTypes.bool,
  onChange: PropTypes.func
}
AdasAccordionSummary.propTypes = { children: PropTypes.node, expandIcon: PropTypes.node, className: PropTypes.string }
AdasAccordionDetails.propTypes = { children: PropTypes.node, className: PropTypes.string }
